export default __webpack_public_path__ + "static/media/ic-id.d821099f.svg";